import { updateObject } from "../../../../shared";
import { globalConstants, consumerResponsesConstants } from "../../constants";

const { SUCCESS } = globalConstants;
const { CUSTOMER_RESPONSE_DATA, GET_ORDER_DETAIL } = consumerResponsesConstants;

const initialState = {
  orderDetail: {},
  customerUserData: [],
  allCustomerUserData: [],
  consumerResponseDataPagination: {
    size: 5,
    number: 0,
    totalElements: 0,
  },
};

export const sharedConsumerResponsesReducer = (
  state = initialState,
  action
) => {
  if (action.type === CUSTOMER_RESPONSE_DATA + SUCCESS) {
    return updateObject(state, {
      allCustomerUserData: action.data.pageData,
      customerUserData: action.data.pageData.userResponses,
      consumerResponseDataPagination: action.data.page,
    });
  } else if (action.type === GET_ORDER_DETAIL + SUCCESS) {
    return updateObject(state, {
      orderDetail: action.data,
    });
  } else {
    return state;
  }
};
